export default __webpack_public_path__ + "static/media/guinea-bissau.dfc04d0b.png";